<template>
  <div class="Risk">
    <!-- 当前位置 -->
    <!-- <div class="box">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <span class="dangqian">当前位置：</span>
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>
          <div class="red">特色品种（收费栏目）</div>
        </el-breadcrumb-item>
      </el-breadcrumb>
    </div> -->
    <!-- 布局容器 -->
    <div class="container">
      <!-- 左侧 -->
      <!-- <div class="left">
        <div class="top">
          <i class="iconfont iconbianzu10beifen3"></i>
          <p>北京同仁堂</p>
        </div>
      </div> -->
      <!-- 右侧 -->
      <div class="right">
        <div class="box1" v-for="(item, index) in boxContent" :key="index">
          <img :src="item.dirFilePath" class="img" />
          <div style="border-bottom: 1px solid #fff;"></div>
          <div class="title">{{ item.title }}</div>
          <div class="textContent">{{ item.description }}</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      boxContent: [],
      navigationId: ''
    };
  },
  created() {
    this.navigationId = this.$route.params.navigationId
    this.lookPictureFun();
  },
  methods: {
    lookPictureFun() {
      this.Api.SearchCompanyProduct_AllApi({
        navigationId: this.navigationId
      }).then((res) => {
        let url = res.Data.documentsIISHttp;
        this.boxContent = res.Data.CompanyProductData;
        for (let i = 0; i < res.Data.CompanyProductData.length; i++) {
          this.boxContent[i].dirFilePath = url + this.boxContent[i].dirFilePath;
        }
      });
    },
  },
};
</script>
<style lang="less" scoped>
/deep/.el-tabs__nav-wrap::after {
  content: "";
  height: 1px !important;
  background-color: #e4e7ed !important;
  z-index: 1;
}

/deep/ .el-tabs__item {
  font-size: 16px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: rgba(102, 102, 102, 1);
  padding: 0;
  margin: 0 20px;
}

/deep/ .is-active {
  color: red;
  border-bottom: 2px solid #00345e;
}

/deep/ .el-tabs__active-bar {
  display: none;
}

// .Risk {
//   background: #f2f2f2;
//   width: 80%;
//   margin: 0 auto;
//   margin-bottom: 40px;
// }
.container {
  width: 80%;
  height: 100%;
  // display: flex;
  // justify-content: flex-end;
  margin: 0 auto;
  margin-top: 20px;
}

.box {
  width: 100%;
}

/deep/ .el-breadcrumb {
  font-size: 12px;
  color: rgba(102, 102, 102, 1);
  line-height: 12px;
  float: left;
}

.dangqian {
  float: left;
}

/deep/.el-breadcrumb__inner {
  font-weight: 400 !important;
}

.red {
  color: #00345e;
}

// .left {
//   width: 12%;
//   height: 107px;
//   background-color: white;
// }

.top {
  margin-top: 24px;
  position: relative;
  width: 100%;
  height: 52px;
  line-height: 52px;

  background-color: #00345e;
  font-size: 16px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;

  i {
    left: 10px;
  }
}

p {
  padding-left: 40px;
  color: white;
}

.right {
  width: 100%;
  min-height: 546px;
  // /*background-color: white;*/
  box-sizing: border-box;
  background: #fff;
  padding: 30px;
  overflow: auto;
  text-align: left;
  letter-spacing: 0.2ch;
  display: flex;
  // justify-content: space-between;
  justify-content: start;
  flex-wrap: wrap;
  // margin-left: 20px;
}

i {
  position: absolute;
  left: 15px;
  width: 16px;
  height: 16px;
  color: white;
}

/deep/.el-breadcrumb {
  margin: 15px 0 20px 0;
  display: flex;
  align-items: center;
  line-height: 10px;
}

.box1 {
  width: 30%;
  height: 450px;
  border: 1px solid #ccc;
  border-radius: 5px;
  box-shadow: 1px 1px #ccc;
  text-align: center;
  // padding: 5px;
  margin-bottom: 20px;
  padding: 10px;
  margin-right: 15px;
}

.box1:hover {
  box-shadow: 2px 2px 10px 3px #ccc;
}

.img {
  vertical-align: middle;
  width: 90%;
  height: 60%;
  margin: 10px auto;
}

.img:hover {
  width: 100%;
  height: 65%;
  transition-property: width, height;
  transition-duration: 1s;
}

.title {
  font-weight: 600;
  font-size: 20px;
  letter-spacing: 0.2ch;
}

.textContent {
  padding: 10px;
  height: 25%;
  overflow-y: auto;
  letter-spacing: 0;
}
</style>
